module.exports = __webpack_public_path__ + "img/small.6ed78f35.jpg";